import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Marquee } from '../components/Marquee';
import { Manifesto } from '../components/Manifesto';
import { WhyMe } from '../components/WhyMe';
import { Modalidades } from '../components/Modalidades';
import { AboutTeaser } from '../components/AboutTeaser';
import { Certificaciones } from '../components/Certificaciones';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';

export default function Home() {
    return (
        <main>
            <Navbar />
            <Hero />
            <Marquee />
            <Manifesto />
            <WhyMe />
            <Modalidades />
            <AboutTeaser />
            <Certificaciones />
            <Contact />
            <Footer />
        </main>
    );
}
